// extracted by mini-css-extract-plugin
module.exports = {"container":"_2GWfSvYD","title":"_eZ3_wpKm","firstHistoryConfetti":"_q6nQPfRk","secondHistoryConfetti":"_V9D-80G9","button":"_6wB8-0pl"};